import json from './sprite.js';

export default {
    handle: 'ENG_SPT1-Puppy_225002807',
    label: 'en_SPT1-Puppy_225002807',
    json,
};
